import { useEffect, useState } from 'react';
import { useStepsStore } from '../../stores/StepsStore';

const VerificationMethodsChoose = ({ show = false }) => {
    const [numberOfAvailable, setNumberOfAvailable] = useState(0);
    const [showEmail, setShowEmail] = useState(true);
    const [showPhone, setShowPhone] = useState(true);
    const [showSource, setShowSource] = useState(true);
    const { setVerificationType, available_verifications } = useStepsStore();

    useEffect(() => {
        let numberOfAvailable = 0;
        if (available_verifications.email.available) {
            numberOfAvailable++;
        }
        if (available_verifications.phone.available) {
            numberOfAvailable++;
        }
        if (available_verifications.source.available) {
            numberOfAvailable++;
        }
        if (numberOfAvailable > 1) {
            setShowEmail(false);
            setShowPhone(false);
            setShowSource(false);
        }
        setNumberOfAvailable(numberOfAvailable);
    }, [available_verifications]);

    useEffect(() => {
        if (showEmail) {
            setVerificationType('email');
        } else if (showPhone) {
            setVerificationType('phone');
        } else if (showSource) {
            setVerificationType('source');
        }
    }, [showEmail, showPhone, showSource]);

    if (show) {
        return (
            <>
                {numberOfAvailable > 1 ?
                    <div className='verification-radios'>
                        <label>Pick a verification method</label>
                        <div className='verification-options'>
                            {available_verifications.email.available ?
                                <label>
                                    <input type="radio" name="flag"
                                        value="email" checked={showEmail} onChange={() => { setShowPhone(false); setShowSource(false); setShowEmail(!showEmail); }}
                                    />
                                    Use Email verification
                                </label>
                                : ''}
                            {available_verifications.phone.available ?
                                <label>
                                    <input
                                        type="radio"
                                        name="flag"
                                        value="phone"
                                        checked={showPhone}
                                        onChange={() => { setShowSource(false); setShowEmail(false); setShowPhone(!showPhone); }}
                                    />
                                    Use Phone verification
                                </label>
                                : ''}
                            {available_verifications.source.available ?
                                <label>
                                    <input
                                        type="radio"
                                        name="flag"
                                        value="source"
                                        checked={showSource}
                                        onChange={() => { setShowPhone(false); setShowEmail(false); setShowSource(!showSource); }}
                                    />
                                    Use Order Id verification
                                </label>
                                : ''}
                        </div>
                    </div>
                    : ''}
            </>
        );
    } else {
        return '';
    }
};

export default VerificationMethodsChoose;